import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import debounce from "lodash/debounce";

import {
  setProductQuantity,
  updateCheckoutItemQuantity,
} from "../../../redux/slices/cartSlice";

import "./styles.css";
import { REACT_APP_URL } from "../../../config";
import { updateCartProductQuantity } from "../../../redux/slices/newCartSlice";
import {
  calculateFinalAmountWithGST,
  FinialAmount,
} from "../../../utils/usefullFunction";
import { formatAmount } from "../../../utils/usefullFunction";
// import { CiDiscount1 } from "react-icons/ci";
import { IoIosSettings } from "react-icons/io";
import { FaPlus } from "react-icons/fa";
import { FaMinus } from "react-icons/fa";
import { Link } from "react-router-dom";

const CustomizeProductCard = ({
  product,
  calculateCustomizedPrice,
  combination,
  setProductPrice,
  setProductUnitPrice,
  handleDeleteCartItem,
  handleMoveToWishlist,
  userdetails,
  onDiscountClick = () => {},
}) => {
  const dispatch = useDispatch();

  const [initialPrice, setInitialPrice] = useState(0);
  const [quantity, setQuantity] = useState(1);
  const [price, setPrice] = useState(0);
  const [cartProduct, setCartProduct] = useState(null);
  const [priceWithGST, setPriceWithGST] = useState(0);

  useEffect(() => {
    if (cartProduct) {
      const product = cartProduct?.customizeProduct;
      // for front
      const FrontPrice = calculateCustomizedPrice(
        product,
        cartProduct?.FrontCombinations,
        "FixedPrice",
        {
          width: cartProduct?.customizeProductWidth,
          height: cartProduct?.customizeProductHeight,
        }
      );

      let BackPrice = 0;

      // for back
      if (
        cartProduct?.SAF?.length > 0 &&
        cartProduct?.customizedProductBackSelected === "SAF"
      ) {
        BackPrice = calculateCustomizedPrice(
          product,
          cartProduct?.SAFCombinations,
          "FixedPriceSAF",
          {
            width: cartProduct?.customizeProductWidth,
            height: cartProduct?.customizeProductHeight,
          }
        );
      } else if (
        cartProduct?.CB?.length > 0 &&
        cartProduct?.customizedProductBackSelected === "CB"
      ) {
        BackPrice = calculateCustomizedPrice(
          product,
          cartProduct?.CBCombinations,
          "FixedPriceCB",
          {
            width: cartProduct?.customizeProductWidth,
            height: cartProduct?.customizeProductHeight,
          }
        );
      } else if (
        cartProduct?.IB?.length > 0 &&
        cartProduct?.customizedProductBackSelected === "IB"
      ) {
        BackPrice = calculateCustomizedPrice(
          product,
          cartProduct?.IBCombinations,
          "FixedPriceIB",
          {
            width: cartProduct?.customizeProductWidth,
            height: cartProduct?.customizeProductHeight,
          }
        );
      }

      const total = FrontPrice + BackPrice;

      const { finalAmount, priceWithGST } = calculateFinalAmountWithGST(
        total,
        cartProduct?.customizeProductWidth,
        cartProduct?.customizeProductHeight,
        product?.GSTIN ?? 0
      );
      // const finalAmount = CustomizedFinialAmount(total, product);

      if (cartProduct?.totalAmountAfterDiscount) {
        setPrice(
          Number(cartProduct?.totalAmountAfterDiscount) *
            Number(cartProduct?.quantity)
        );
      } else {
        setPrice(Number(finalAmount) * Number(cartProduct?.quantity));
      }
      setInitialPrice(Number(finalAmount));
      setPriceWithGST(Number(priceWithGST));
      setQuantity(cartProduct?.quantity);
    }
  }, [cartProduct, calculateCustomizedPrice]);

  useEffect(() => {
    if (combination) {
      setCartProduct(combination);
    }
  }, [combination]);

  useEffect(() => {
    if (cartProduct) {
      setProductPrice((prevState) => ({
        ...prevState,
        [cartProduct?._id]: price,
      }));

      setProductUnitPrice((prevState) => ({
        ...prevState,
        [cartProduct?._id]: {
          unit: initialPrice + "",
          discount: cartProduct?.totalAmountAfterDiscount ?? "",
        },
      }));
    }
  }, [price, setProductPrice, setProductUnitPrice, initialPrice, cartProduct]);

  const debouncedDispatch = debounce((id, newQuantity) => {
    dispatch(
      updateCartProductQuantity({
        id,
        productData: { quantity: newQuantity },
      })
    );
  }, 500);

  const handleQuantityChange = (value) => {
    const newQuantity = Math.max(1, quantity + value);
    setQuantity(newQuantity);
    const currentPrice = cartProduct?.totalAmountAfterDiscount || initialPrice;
    const newPrice = currentPrice * newQuantity;
    setPrice(newPrice);

    if (cartProduct) {
      if (userdetails && Object.keys(userdetails).length > 0) {
        debouncedDispatch(cartProduct._id, newQuantity);
      } else {
        dispatch(
          setProductQuantity({ _id: cartProduct._id, quantity: newQuantity })
        );
      }
      dispatch(
        updateCheckoutItemQuantity({
          _id: cartProduct._id,
          quantity: newQuantity,
        })
      );
    }
  };

  const handleManualQuantityChange = (e) => {
    const value = e.target.value;
    const numericValue = parseInt(value, 10);

    if (!isNaN(numericValue) && numericValue >= 1) {
      setQuantity(numericValue);
      const currentPrice =
        cartProduct?.totalAmountAfterDiscount || initialPrice;
      const newPrice = currentPrice * numericValue;
      setPrice(newPrice);

      if (cartProduct) {
        if (userdetails && Object.keys(userdetails).length > 0) {
          debouncedDispatch(cartProduct._id, numericValue);
        } else {
          dispatch(
            setProductQuantity({ _id: cartProduct._id, quantity: numericValue })
          );
        }
      }
    } else if (value === "") {
      setQuantity(""); // allow temporary empty state while typing
    }
  };

  const unit =
    cartProduct?.customizeProductWidth && cartProduct?.customizeProductHeight
      ? "Sq.ft"
      : cartProduct?.customizeProductWidth
      ? "Length"
      : cartProduct?.customizeProductHeight
      ? "Rft"
      : "Pice";

  return (
    <tr>
      <td>
        <Link
          to={`/customized-product/${product?.Collection[0]?.url}/${product?.Urlhandle}?cartId=${combination?._id}`}
        >
          <ImageCreation
            customuizedProductFront={combination?.FrontCombinations}
          />
        </Link>
      </td>
      <td>
        <p
          className="m-0"
          style={{ fontSize: "18px", backgroundColor: "transparent" }}
        >
          {product?.ProductName}
        </p>
        <div style={{ fontSize: "14px", color: "#555" }}>
          <strong>SIZE : </strong>
          {cartProduct?.customizeProductWidth
            ? `Width ${cartProduct.customizeProductWidth} ft`
            : ""}
          {cartProduct?.customizeProductWidth &&
          cartProduct?.customizeProductHeight
            ? " × "
            : ""}
          {cartProduct?.customizeProductHeight
            ? `Height ${cartProduct.customizeProductHeight} ft`
            : ""}
          {` × ₹${priceWithGST} Rate/${unit}`}
        </div>
        <div
          className="btn-group"
          style={{ zoom: "70%" }}
          role="group"
          aria-label="Basic mixed styles example mx-auto"
        >
          <button
            type="button"
            className="btn btn-success"
            style={{ backgroundColor: "#475B52" }}
            onClick={() =>
              handleMoveToWishlist(cartProduct?._id, "customizeProducts")
            }
          >
            MOVE TO WISHLIST
          </button>
          <button
            type="button"
            className="btn btn-danger"
            onClick={() =>
              handleDeleteCartItem(combination?._id, "customizeProducts")
            }
          >
            REMOVE PERMANENTLY
          </button>
          <button
            type="button"
            onClick={() =>
              onDiscountClick({
                type: "customizeProduct",
                productName: product?.ProductName,
                _id: cartProduct?._id,
                amount: `₹${formatAmount(initialPrice)}`,
                salePrice: initialPrice,
                currentDiscount: cartProduct?.totalAmountAfterDiscount,
              })
            }
            className="btn btn-warning"
          >
            <IoIosSettings size={25} />
          </button>
        </div>
      </td>
      <td className="text-center">{product?.SKU || ""}</td>
      <td className="text-center">
        {cartProduct?.totalAmountAfterDiscount !== 0 && (
          <>
            <strike>{`₹${formatAmount(initialPrice)}`}</strike> &nbsp; &nbsp; ₹
            {formatAmount(cartProduct?.totalAmountAfterDiscount)}
          </>
        )}

        {(!cartProduct?.totalAmountAfterDiscount ||
          cartProduct?.totalAmountAfterDiscount === 0) &&
          `₹${formatAmount(initialPrice)}`}
      </td>
      <td>
        <div className="qty" style={{ backgroundColor: "transparent" }}>
          <div className="col-lg-12">
            <div className="input-group">
              <span className="input-group-btn">
                <button
                  type="button"
                  className="quantity-left-minus btn btn-default btn-number"
                  style={{
                    backgroundColor: "#475B52",
                    userSelect: "none",
                  }}
                  data-type="minus"
                  data-field=""
                  onClick={() => handleQuantityChange(-1)}
                >
                  <FaMinus style={{ color: "#fff" }} />
                </button>
              </span>
              &nbsp;
              <input
                style={{
                  textAlign: "center",
                  maxWidth: "65px",
                  borderRadius: "5px",
                  // cursor: "default",
                  // userSelect: "none",
                }}
                type="text"
                id="quantity"
                name="quantity"
                className="form-control input-number"
                min={1}
                onChange={handleManualQuantityChange}
                value={quantity}
              />
              &nbsp;
              <span className="input-group-btn">
                <button
                  type="button"
                  className="quantity-right-plus btn btn-default btn-number"
                  style={{
                    backgroundColor: "#475B52",
                    userSelect: "none",
                  }}
                  data-type="plus"
                  data-field=""
                  onClick={() => handleQuantityChange(1)}
                >
                  <FaPlus style={{ color: "#fff" }} />
                </button>
              </span>
            </div>
          </div>
        </div>
      </td>
      <td style={{ textAlign: "right", fontWeight: "600" }}>
        ₹{formatAmount(price)}
      </td>
    </tr>

    // <div style={{ alignSelf: "end" }}>
    //   <div
    //     className="btn-group"
    //     role="group"
    //     aria-label="Basic mixed styles example mx-auto"
    //   >
    //     <button
    //       type="button"
    //       className="btn btn-success"
    //       onClick={() =>
    //         handleMoveToWishlist(cartProduct?._id, "customizeProducts")
    //       }
    //     >
    //       MOVE TO WISHLIST
    //     </button>
    //     <button
    //       type="button"
    //       className="btn btn-danger"
    //       onClick={() =>
    //         handleDeleteCartItem(cartProduct?._id, "customizeProducts")
    //       }
    //     >
    //       REMOVE PERMANENTLY
    //     </button>
    //   </div>
    // </div>
    // </div>
    // </div>
    // </div>
  );
};

export default CustomizeProductCard;

const ImageCreation = ({ customuizedProductFront }) => {
  return (
    <>
      <div
        style={{
          position: "relative", // Add position relative to contain absolute positioning of child images
          // height: "80vh",
          backgroundColor: "transparent",
        }}
      >
        {customuizedProductFront &&
          customuizedProductFront.length > 0 &&
          customuizedProductFront.map((img, i) => (
            <img
              key={i}
              src={`${REACT_APP_URL}/images/parameterPosition/${img?.pngImage}`}
              alt="Preview"
              style={{
                position: i === 0 ? "relative" : "absolute", // Position images absolutely within the parent div
                top: `${img?.positionY}%`,
                left: `${img?.positionX}%`,
                // width: "300px",
                height: "15vh",
                objectFit: "cover", // Ensure the image fills its container without distortion
                zIndex: img?.attributeId?.BurgerSque, // Use zIndex from the image attribute
              }}
            />
          ))}
      </div>
    </>
  );
};
